import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Flex, Modal, Spin, Tooltip, Typography } from "antd";
import { useForm } from "antd/es/form/Form";
import _ from "lodash";
import React, { useState } from "react";
import { ContentPartFilter } from "../../../../components/content-part/ContentPartFilter";
import { PageHeader } from "../../../../components/page-header";
import { EntTypeAnimalFilter } from "../../../../models/filters/TypeAnimalFilter";
import { EntTypeAnimal } from "../../../../models/handBooks/typeAnimal";
import { useLazyGetAnimalTypeListQuery } from "../../../../redux/api/handBooksApi/animalTypesApi";
import { AddTypeAnimalModal } from "./AddTypeAnimalModal";
import { useTypeAnimal } from "./useTypeAnimal";
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import { useGetDataOnScroll } from "../../../../components/getDataOnScrollProps/useGetDataOnScrollProps";
import { FilterByNameHB } from "../../../../components/filterByNameHB/FilterByNameHB";

enum FormField {
  name
}

export const TypeAnimal = () => {

  const [form] = useForm();
  const { t } = useTranslation()
  const [modal, contextHolder] = Modal.useModal();
  const [selectedAnimalType, setSelectedAnimalType] = useState<EntTypeAnimal>(new EntTypeAnimal());
  const [showModal, setShowModal] = useState<boolean>(false);
  const { onAddTypeAnimal, onEditTypeAnimal, onDeleteTypeAnimal } = useTypeAnimal(modal, () => {
	searchHandleClick()
  })
  const [height, setHeight] = useState<number>(0);

  const [getData] = useLazyGetAnimalTypeListQuery();
  const {
	fetching,
	data,
	access,
	filter,
	totalItems,
	setData,
	setFetching,
	setFilter,
	setCurrentPage
  } = useGetDataOnScroll<EntTypeAnimal, EntTypeAnimalFilter>({
	initialFilter: new EntTypeAnimalFilter(),
	query: getData
  });

  const openAddModal = (item: EntTypeAnimal) => {
	setSelectedAnimalType(item);
	setShowModal(true);
  }
  const setEntityFromFields = (): EntTypeAnimalFilter => {
	let item: EntTypeAnimalFilter = _.clone(filter);
	item.name = form.getFieldValue(FormField.name) ?? null;
	item.page = 1;
	return item;
  }

  const clearFields = () => {
	form.setFields([
	  { name: FormField.name, value: null },
	]);
  }

  const searchHandleClick = () => {
	setFilter(setEntityFromFields());
	setData([]);
	setCurrentPage(0);
	setFetching(true);
  }

  const table = (
	<div style={ { maxHeight: `${ height }px`, overflow: 'auto' } }>
	  <table>
		<thead>
		<tr>
		  <th style={ { width: "40px" } }>#</th>
		  <th>{ t('general.nameKy') }</th>
		  <th>{ t('general.nameRu') }</th>
		  <th>{ t('titles.units_of_measurement') }</th>
		  <th style={ { width: "120px" } }></th>
		</tr>
		</thead>
		<tbody>
		{ fetching ?
		  <tr>
			<th colSpan={ 5 }>
			  <Spin spinning={ fetching } style={ {
				width: '100%',
				height: '180px',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center'
			  } }/>
			</th>
		  </tr>
		  : <></> }
		{ data.map((item, index) => (
		  <tr key={ item.id }>
			<td>{ ++index }</td>
			<td>{ item?.nameKy }</td>
			<td>{ item?.nameRu }</td>
			<td>{ i18n.language === 'ru' ? item.unitMeasurement?.nameRu : item.unitMeasurement?.nameKy }</td>
			<td>
			  <Flex gap="small">
				{ access && access.methodPut && (
				  <Tooltip title={ t('general.edit') }>
					<Button className='btn_edit' onClick={ () => {
					  openAddModal(item)
					} } type="primary" shape="circle" icon={ <EditOutlined/> }/>
				  </Tooltip>
				) }
				{ access && access.methodDelete && (
				  <Tooltip title={ t('general.delete') }>
					<Button className='btn_edit' danger onClick={ () => {
					  onDeleteTypeAnimal(item)
					} } type="primary" shape="circle" icon={ <DeleteOutlined/> }/>
				  </Tooltip>
				) }
			  </Flex>
			</td>
		  </tr>
		)) }
		</tbody>
	  </table>
	</div>
  );
  return (
	<>
	  <PageHeader
		title={ t('titles.animal_species') }
		additionalInfo={
		  <Typography.Text style={ { marginBottom: '0.5em', display: 'block' } }
						   type="secondary">{ t('general.records_found') } { totalItems }</Typography.Text>
		}/>
	  { access && access.methodPost && (
		<Button type="primary" icon={ <PlusOutlined/> } onClick={ () => {
		  openAddModal(new EntTypeAnimal)
		} }>
		  { t('handbooks.animal_species.add_animal_species') }
		</Button>
	  ) }
	  <ContentPartFilter
		filter={ <FilterByNameHB onSearch={ searchHandleClick }
								   onReset={ () => {
									 clearFields();
									 searchHandleClick()
								   } } formField={ FormField } form={ form }/> }
		setHeight={ setHeight }
		table={ table }
		width={ 800 }
	  />
	  <AddTypeAnimalModal
		typeAnimal={ selectedAnimalType }
		show={ showModal }
		onHide={ () => {
		  setShowModal(false)
		} }
		onSubmit={ selectedAnimalType.id !== 0 ? onEditTypeAnimal : onAddTypeAnimal }
	  />
	  { contextHolder }
	</>
  )
}
